<template>
  <div class="containermod">
    <InputUl
      @input="updateInputEmail"
      :width="'250px'"
      :inpType="'email'"
      :inpName="'miEmail'"
      :inpTitleStart="'Mi email es'"
      :inpTitleEnd="''"
    />
    <InputUl
      @change="updateInputAceptSendEmails"
      :inpType="'checkbox'"
      :inpName="'offer'"
      :inpTitleStart="''"
      :inpValue="true"
      :inpTitleEnd="'Quiero recibir ofertas, novedades y/o beneficios de la obra social.'"
    />
  </div>
</template>

<script>
import InputUl from "./../form/InputUl";
export default {
  name: "Newsletter",
  components: { InputUl },
  data() {
    return {
      newsletterData: {
        email: "",
        aceptSendEmails: true,
      },
    };
  },
  created() {
    window.scroll(0, document.body.scrollHeight);
  },
  methods: {
    updateInputEmail(value) {
      this.newsletterData.email = value;
      this.$emit("change", this.newsletterData);
    },
    updateInputAceptSendEmails(value) {
      this.newsletterData.aceptSendEmails = value;
      this.$emit("change", this.newsletterData);
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 480px) {
  .containermod {
    margin: 0 20px;
  }
  .is-flex {
    display: block !important;
  }
}
</style>
